import script from "./ProfilerHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilerHome.vue?vue&type=script&setup=true&lang=js"

import "./ProfilerHome.vue?vue&type=style&index=0&id=0b72f6ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b72f6ec"]])

export default __exports__